import { FC } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import { IdTypeEnum, NameTypeEnum } from 'types/customer';
import CHN from './CHN';
import Common from './Common';
import Common2 from './Common2';
import { getNameType } from './helper';
import { RealNameInfoFormutil } from './type';
import USA from './USA';

interface RealNameInfoProps {
    disabled?: boolean;
    $formutil: $Formutil<RealNameInfoFormutil>;
    fields?: string[]; // 打回模式中的值
    // 当需要固定某个nameType时, 可以传入
    nameType?: NameTypeEnum;
    idType?: IdTypeEnum;
    country?: string;
}

const RealNameInfo: FC<RealNameInfoProps> = props => {
    const { disabled, $formutil, nameType, idType, country } = props;
    const { name_type: formNameType } = $formutil.$params;
    const curNameType = nameType || formNameType || getNameType({ idType, country });

    switch (curNameType) {
        case NameTypeEnum.USA:
            return <USA disabled={disabled} />;
        case NameTypeEnum.COMMON:
            return <Common disabled={disabled} />;
        case NameTypeEnum.COMMON2:
            return <Common2 disabled={disabled} />;
        case NameTypeEnum.CHN:
            return <CHN disabled={disabled} />;
        default:
            const _checkNever: never = curNameType;

            return null;
    }
};

export default connect(RealNameInfo);
export * from './helper';
export * from './type';
